var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGifticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332.547,
    height: 193.168,
    viewBox: "0 0 332.547 193.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(-1.312 -0.004)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.01 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5724",
    "data-name": "Group 5724",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11585",
    "data-name": "Path 11585",
    d: "M3357.347,259.656a61.548,61.548,0,0,1,3.292-5.2c8.475-12.209,21.041-23.977,35.778-23.535l.011-.089a32.038,32.038,0,0,0-18.922,4.206c-9.455,5.1-18.667,14.809-23.706,22.275l3.547,2.345Z",
    transform: "translate(-3146.815 -216.432)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11586",
    "data-name": "Path 11586",
    d: "M3924.44,21.249l1-6.867-5.091-4.714a.953.953,0,0,1,.486-1.639l6.839-1.174,2.91-6.3a.953.953,0,0,1,1.709-.044l3.23,6.141,6.889.821a.954.954,0,0,1,.57,1.613l-4.843,4.969,1.349,6.806a.954.954,0,0,1-1.357,1.041l-6.222-3.07-6.056,3.386a.954.954,0,0,1-1.409-.97Z",
    transform: "translate(-3678.108 -0.004)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11587",
    "data-name": "Path 11587",
    d: "M1758.217,114.526l-.907,3.364,2.719,2.287-1.284,3.7,3.647,1.542-1.268,4.247,3.183,1.834-.551,4.285-1.622-.209.412-3.2-3.359-1.935,1.218-4.083-3.708-1.568,1.417-4.081-2.656-2.233.841-3.118-2.05-1.1.774-1.44Z",
    transform: "translate(-1645.984 -105.848)",
    fill: "#9bc1f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5719",
    "data-name": "Group 5719",
    transform: "translate(67.158 124.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11588",
    "data-name": "Path 11588",
    d: "M291.6,3473.729a10.662,10.662,0,1,1-15.059-.825A10.661,10.661,0,0,1,291.6,3473.729Z",
    transform: "translate(-272.997 -3470.182)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11589",
    "data-name": "Path 11589",
    d: "M395.261,3609.3a5.7,5.7,0,1,0,8.49-7.609l-8.491,7.609Z",
    transform: "translate(-387.714 -3593.574)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11591",
    "data-name": "Path 11591",
    d: "M23.857,2818.8l-2.786-1.58a15.551,15.551,0,0,1-2.617,3.157,1.95,1.95,0,0,1-2.666-.038l-.089-.085a1.946,1.946,0,0,1,.051-2.854,11.344,11.344,0,0,0,2.352-2.871c.948-1.672.952-3.181-.222-3.847-1.115-.632-2.351-.093-4.315,1.662-2.835,2.539-5.516,3.849-8.36,2.235-2.581-1.464-3.573-4.429-2.409-7.917l-2.786-1.58,1.63-2.874,2.581,1.463a14.4,14.4,0,0,1,1.9-2.457,1.946,1.946,0,0,1,2.737-.031h0a1.947,1.947,0,0,1,0,2.8,10.374,10.374,0,0,0-1.826,2.369c-1.081,1.907-.609,2.988.212,3.454.968.548,2.166-.129,4.518-2.089,3.211-2.792,5.622-3.285,8.261-1.787,2.61,1.479,3.791,4.591,2.466,8.3l2.991,1.7-1.63,2.874Z",
    transform: "translate(41.67 -2637.96)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11592",
    "data-name": "Path 11592",
    d: "M4530.164,1188.59l-1.844,4.6-7.725-2.15-3.526,6.389-6.044-.664-.335,3.06,8.083.888,3.34-6.055,8.037,2.237,2.774-6.918Z",
    transform: "translate(-4232.305 -1115.234)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11593",
    "data-name": "Path 11593",
    d: "M4548.647,3303.8l1.618-4.016a21.008,21.008,0,0,1-4.7-2.942,2.635,2.635,0,0,1-.427-3.579l.1-.135a2.63,2.63,0,0,1,3.833-.442,15.354,15.354,0,0,0,4.267,2.637c2.41.971,4.433.706,5.114-.986.647-1.606-.3-3.166-3-5.483-3.91-3.344-6.144-6.7-4.491-10.8,1.5-3.72,5.294-5.581,10.175-4.646l1.618-4.016,4.144,1.67-1.5,3.719a19.44,19.44,0,0,1,3.633,2.111,2.632,2.632,0,0,1,.531,3.662h0a2.633,2.633,0,0,1-3.754.508,14,14,0,0,0-3.5-2.023c-2.748-1.107-4.112-.281-4.589.9-.562,1.395.56,2.879,3.607,5.679,4.315,3.8,5.407,6.945,3.874,10.749-1.516,3.762-5.474,5.9-10.675,4.788l-1.737,4.312-4.143-1.67Z",
    transform: "translate(-4280.576 -3142.792)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11594",
    "data-name": "Path 11594",
    d: "M608.537,1298.242a1.42,1.42,0,0,1-.074,1.8,13.966,13.966,0,0,1-4.163,3.08,11.226,11.226,0,0,1-8.606.695,10.344,10.344,0,0,1-4.8-3.605l-1.575.767a1.078,1.078,0,0,1-1.441-.5l-.02-.041a1.078,1.078,0,0,1,.5-1.441l1.292-.63c-.257-.425-.435-.688-.553-.93a10.514,10.514,0,0,1-.567-1.473l-1.332.649a1.078,1.078,0,0,1-1.441-.5h0a1.078,1.078,0,0,1,.5-1.442l1.616-.787a11.072,11.072,0,0,1,.242-5.964,11.913,11.913,0,0,1,6.157-6.748,12.181,12.181,0,0,1,4.112-1.227,1.454,1.454,0,0,1,1.592,1.241l0,.025a1.458,1.458,0,0,1-1.256,1.647,10.438,10.438,0,0,0-3.193,1,7.76,7.76,0,0,0-4.023,4.358,6.469,6.469,0,0,0-.122,3.957l9.087-4.427a1.078,1.078,0,0,1,1.441.5h0a1.078,1.078,0,0,1-.5,1.441l-9.491,4.624c.176.464.352.928.49,1.211.177.364.354.727.631,1.192l9.511-4.634a1.1,1.1,0,0,1,1.471.507h0a1.1,1.1,0,0,1-.507,1.472L594.4,1298.5a6.851,6.851,0,0,0,2.992,2.14,7.58,7.58,0,0,0,6.053-.5,11.885,11.885,0,0,0,2.977-2.07,1.42,1.42,0,0,1,2.114.169h0Z",
    transform: "translate(-549.496 -1200.954)",
    fill: "#86b1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11595",
    "data-name": "Path 11595",
    d: "M205.188,1850.686l-4.7.478-1.6-7.482-6.962-.15-2.116-5.4-2.735,1.071,2.829,7.226,6.6.142,1.668,7.783,7.076-.718Z",
    transform: "translate(-175.525 -1724.687)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11596",
    "data-name": "Path 11596",
    d: "M4063.06,1081.516l2.953.974s4.681-1.517,5.143-2.471.591-3.269,1.257-3.332a2.017,2.017,0,0,1,2.26,1.738c.223,1.151-1.462,4.474-1.2,4.828a16.14,16.14,0,0,0,3.081,1.254,2.3,2.3,0,0,1,1.523,1.856v0a1.267,1.267,0,0,1-.792,1.361l-.849.328.271.877a1.265,1.265,0,0,1-.8,1.571l-.658.22.21.535a1.266,1.266,0,0,1-.818,1.674l-.574.167.024.154a1.265,1.265,0,0,1-.921,1.415l-.57.149-7.863-2.6a5.6,5.6,0,0,1-1.993-1.157l-2.612-1.378a.649.649,0,0,1-.3-.789l2.421-6.971a.646.646,0,0,1,.81-.409Z",
    transform: "translate(-3809.235 -1010.228)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11597",
    "data-name": "Path 11597",
    d: "M533.479,814.845c-.065-.185-1.64-2.88-3.675-5.806-9.461-13.631-23.491-26.768-39.943-26.275l-.012-.1a35.773,35.773,0,0,1,21.125,4.7c10.555,5.69,20.839,16.533,26.466,24.867l-3.961,2.618Z",
    transform: "translate(-459.619 -734.19)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11598",
    "data-name": "Path 11598",
    d: "M229.913,548.674l-1.113-7.666,5.684-5.263a1.065,1.065,0,0,0-.543-1.831l-7.634-1.31-3.249-7.032a1.064,1.064,0,0,0-1.908-.049l-3.605,6.856-7.692.916a1.065,1.065,0,0,0-.636,1.8l5.406,5.548-1.505,7.6a1.065,1.065,0,0,0,1.515,1.161l6.947-3.427,6.762,3.78a1.064,1.064,0,0,0,1.573-1.082Z",
    transform: "translate(-196.02 -492.556)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11599",
    "data-name": "Path 11599",
    d: "M4718.779,2738.681l.533-1.817a7.618,7.618,0,0,0,6.05-5.156,16.018,16.018,0,0,0,.563-2.6l-3.78-1.088.672-2.29,3.413.982a24.918,24.918,0,0,1,.749-4.041,7.06,7.06,0,0,1,9.125-5.058,9.776,9.776,0,0,1,2.726,1.213,1.321,1.321,0,0,1,.366,1.825h0a1.355,1.355,0,0,1-1.84.4,8.242,8.242,0,0,0-2.009-.859c-2.862-.824-4.612.8-5.37,3.381a20.113,20.113,0,0,0-.7,4.015l5.285,1.521-.673,2.29-4.991-1.437a13.125,13.125,0,0,1-1.341,4.028,7.944,7.944,0,0,1-3.685,3.2l-.022.073,9.646,2.776a1.33,1.33,0,0,1,.916,1.65l-.028.1a1.347,1.347,0,0,1-1.667.907l-13.938-4.012Z",
    transform: "translate(-4427.552 -2549.579)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11600",
    "data-name": "Path 11600",
    d: "M21.168,1200.027,22.963,1197l-1.48-3.2a.484.484,0,0,1,.546-.676l3.438.77,2.583-2.4a.484.484,0,0,1,.811.31l.33,3.508,3.077,1.717a.484.484,0,0,1-.044.867l-3.234,1.4-.682,3.457a.484.484,0,0,1-.838.226l-2.329-2.644-3.5.42A.484.484,0,0,1,21.168,1200.027Z",
    transform: "translate(-19.798 -1117.839)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11601",
    "data-name": "Path 11601",
    d: "M5189.817,2115.567l-4.306-.347-.588,3.983-4.257-.156-1.031,3.738-3.205.4.2,1.623,4.287-.541.977-3.542,4.43.161.578-3.918,3.9.316Z",
    transform: "translate(-4856.958 -1984.676)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11602",
    "data-name": "Path 11602",
    d: "M1491.341,369.129l-.263-4.312-4.026-.02-.446-4.236-3.846-.494-.852-3.116-1.577.431,1.141,4.167,3.644.468.465,4.407,3.96.02.238,3.908Z",
    transform: "translate(-1388.969 -334.92)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11603",
    "data-name": "Path 11603",
    d: "M115.619,2550.424l3.255,1.243,2.55-2.474,3.55,1.651,1.9-3.473,4.1,1.69,2.147-2.981,4.207.981-.372,1.592-3.146-.734-2.266,3.146-3.938-1.624-1.935,3.531-3.917-1.822-2.49,2.416-3.017-1.152-1.3,1.928-1.355-.916Z",
    transform: "translate(-106.58 -2388.945)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11604",
    "data-name": "Path 11604",
    d: "M3199.831,394.49l-.211,2.623-4.258.126-.781,3.8-3.171.616.312,1.605,4.241-.823.74-3.6,4.43-.132.317-3.947Z",
    transform: "translate(-2994.447 -370.144)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5720",
    "data-name": "Group 5720",
    transform: "translate(270.916 21.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11605",
    "data-name": "Path 11605",
    d: "M4410.527,349.29a12.325,12.325,0,1,1-17.427.363A12.325,12.325,0,0,1,4410.527,349.29Z",
    transform: "translate(-4389.67 -345.86)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11606",
    "data-name": "Path 11606",
    d: "M4465.458,413.948l-5.245,1.612-1.646,5.234a.535.535,0,0,1-.948.147l-3.154-4.49-5.486.052a.535.535,0,0,1-.433-.856l3.295-4.387-1.745-5.2a.535.535,0,0,1,.68-.676l5.19,1.779,4.408-3.267a.535.535,0,0,1,.854.438l-.087,5.486L4465.61,413a.535.535,0,0,1-.153.947Z",
    transform: "translate(-4444.812 -400.213)",
    fill: "#fed333"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11607",
    "data-name": "Path 11607",
    d: "M5197.645,1318.374l2.891-.174a.426.426,0,0,0,.277-.684l-1.841-2.409.794-3.067a.387.387,0,0,0-.5-.49l-2.69,1.219-2.4-1.722a.387.387,0,0,0-.588.382l.179,3.163-2.277,2a.427.427,0,0,0,.139.725l2.8.735.993,2.96a.364.364,0,0,0,.674.067l1.552-2.709Z",
    transform: "translate(-4870.949 -1230.072)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11609",
    "data-name": "Path 11609",
    d: "M1957.248,1616.27c-.114.072-.549.2-.652.293l-.8.252a4.764,4.764,0,0,1,3.255,1.245A5.517,5.517,0,0,0,1957.248,1616.27Z",
    transform: "translate(-1835.095 -1516.519)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5723",
    "data-name": "Group 5723",
    transform: "translate(111.454 22.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5722",
    "data-name": "Group 5722",
    transform: "translate(0 73.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11647",
    "data-name": "Path 11647",
    d: "M2854.937,1078.364c-3.087.608-15.422,17.136-15.422,17.136l-.435,1.144s22.317-2.482,23.125-3.436C2864.387,1090.633,2857.474,1077.865,2854.937,1078.364Zm-15.266,17.489c4.072-5.2,13.351-12.806,15.356-14.419a25.3,25.3,0,0,1,4.844,9.653C2857.307,1091.614,2846.183,1095.066,2839.671,1095.852Z",
    transform: "translate(-2775.315 -1077.691)",
    fill: "#82c7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11648",
    "data-name": "Path 11648",
    d: "M2374.087,1071.163c-6.072-3.961-7.738-3.931-9.507-2.927s-8.292,10.362-5.377,13.281,26.043,5,26.043,5l.521-1.414s-5.61-9.981-11.681-13.941Zm-10.865,9.325c-1.349-1.345,2.008-6.948,3.539-8.141.39-.22,15.949,9.681,18.121,13.062C2376.2,1084.47,2364.478,1081.6,2363.222,1080.488Z",
    transform: "translate(-2324.362 -1067.668)",
    fill: "#82c7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11649",
    "data-name": "Path 11649",
    d: "M2759.915,1314.969h1.3a2.335,2.335,0,0,0,2.335-2.335v-3.828a2.335,2.335,0,0,0-2.335-2.335h-1.3a2.335,2.335,0,0,0-2.335,2.335v3.828A2.335,2.335,0,0,0,2759.915,1314.969Z",
    transform: "translate(-2698.845 -1291.732)",
    fill: "#82c7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11650",
    "data-name": "Path 11650",
    d: "M1916.3,1371.106l-105.8-.316a4.591,4.591,0,0,0-4.552,5.282l1.637,10.8,5.3-.011,3.2,54.33a5.5,5.5,0,0,0,5.488,5.177h84.444l3.512-59.708,5-.01,1.775-15.54Z",
    transform: "translate(-1805.901 -1352.082)",
    fill: "#d19901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11652",
    "data-name": "Path 11652",
    d: "M2419.259,1468.283h-64.818l-3.471-74.133h77.011l-3.229,68.978a5.456,5.456,0,0,1-5.492,5.154Z",
    transform: "translate(-2317.33 -1374.001)",
    fill: "#f5c02f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11653",
    "data-name": "Path 11653",
    d: "M2350.29,1387.124l-83.6.222-1.908-16.085,81.9.313a4.591,4.591,0,0,1,4.555,5l-.942,10.551Z",
    transform: "translate(-2236.46 -1352.523)",
    fill: "#f5c02f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11654",
    "data-name": "Path 11654",
    d: "M2295.7,1628.522l79.738-.222-77.209,4.216Z",
    transform: "translate(-2265.471 -1593.7)",
    fill: "#d19901"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2211",
    "data-name": "Rectangle 2211",
    width: 2.219,
    height: 15.887,
    transform: "translate(61.601 18.862)",
    fill: "#82c7e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2212",
    "data-name": "Rectangle 2212",
    width: 2.773,
    height: 59.719,
    transform: "translate(68.035 34.674)",
    fill: "#82c7e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11655",
    "data-name": "Path 11655",
    d: "M1840.745,792.663a179.9,179.9,0,0,0,19.531,6.406c2,.531,5.312,2.045,7.153.7a2.179,2.179,0,0,0,.8-2.877c-1.031-2.054-4.218-2.2-6.233-2.738-6.143-1.637-13.017-3.779-19.837-6.349a2.553,2.553,0,0,0-3.135,1.725,2.584,2.584,0,0,0,1.725,3.135h0Z",
    transform: "translate(-1836.879 -761.933)",
    fill: "#def0f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11656",
    "data-name": "Path 11656",
    d: "M2524.072,389.925c-2.178-16.685-2.037-16.728-2.961-18.3a2.241,2.241,0,0,0-4.054.475c-.506,1.847-.39,1.551,1.968,19.1a2.618,2.618,0,0,0,3.159,1.889,2.664,2.664,0,0,0,1.888-3.159h0Z",
    transform: "translate(-2472.938 -370.541)",
    fill: "#def0f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11657",
    "data-name": "Path 11657",
    d: "M2997.835,477.958a38.62,38.62,0,0,0,4.185-7.134c1.059-2.349,3-5.808,1.181-8.134a1.916,1.916,0,0,0-1.9-.534c-2.467.851-2.938,4.312-3.924,6.474a45.753,45.753,0,0,1-3.865,6.744,2.543,2.543,0,0,0,.87,3.454,2.576,2.576,0,0,0,3.454-.87h0Z",
    transform: "translate(-2919.874 -456.433)",
    fill: "#def0f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11658",
    "data-name": "Path 11658",
    d: "M3432.778,869.858a2.237,2.237,0,0,0-.757-3.008c-1.806-1.347-4.992-.1-6.963.439a44.167,44.167,0,0,0-6.671,2.48,2.562,2.562,0,0,0-.957,3.463,2.6,2.6,0,0,0,3.463.958c8.3-3.457,10.043-1.8,11.887-4.332Z",
    transform: "translate(-3317.678 -835.651)",
    fill: "#def0f8"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifticon);
export default __webpack_public_path__ + "static/media/gifticon.54770d827d6b8fe99ff45b2dfbe89ba9.svg";
export { ForwardRef as ReactComponent };